import { useState } from "react";
import { apiClient } from "../../apis/api-client";
import { decryptPayload } from "../../apis/crypto";
import { API } from "../../Services/apimethod.js"
import {getTokenExp,decryptData} from "@/Services/req_res_decode_encode";
import toast from 'react-hot-toast';

const CONDITIONS = [
  "Hypertension",
  "Heart Attack",
  "Diabetes Mellitus",
  "Polio",
  "Elevated Cholesterol Levels",
  "CABG",
  "Angioplasty",
];

export default function FamilyHistoryCard() {
  const [conds, setConds] = useState<string[]>(CONDITIONS.map(() => "No"));

  const [familyHist, setFamilyHist] = useState("No");

  const [loading, setLoading] = useState(false);

  const [result, setResult] = useState<{
    ok: boolean;
    msg: string;
  } | null>(null);

  const check = async () => {
    try {
      if(getTokenExp()){
             localStorage.clear();
             toast.error('Your login is expired!');
            setTimeout(() => {
                window.location.href = import.meta.env.VITE_LOGINURL;
            }, 2000);
            return false
        }
      setLoading(true);

      const payload = {
        hypertension: conds[0],
        heartAttack: conds[1],
        diabetesMellitus: conds[2],
        polio: conds[3],
        elevatedCholesterol: conds[4],
        cabg: conds[5],
        angioplasty: conds[6],
        familyCancerHistory: familyHist,
      };

      const response = await API.CreateMethod("check-family-history-eligibility", payload);

      const decryptedResponse = decryptData(response?.data);
debugger

      if (response?.status==200) {
        const data = decryptedResponse.data;

        if (data.eligible) {
          setResult({
            ok: true,
            msg: `✓ ${data.message}`,
          });
        } else {
          setResult({
            ok: false,
            msg: `✕ ${data.message}`,
          });
        }
      } else {
        setResult({
          ok: false,
          msg: "✕ Something went wrong.",
        });
      }
    } catch (error) {
   

      setResult({
        ok: false,
        msg: "✕ API Error. Please try again.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <label className="cc-label-normal" style={{ marginTop: 8 }}>
        Have you ever been diagnosed / treated with any of the following?
      </label>

      <div
        style={{
          marginTop: 10,
          display: "flex",
          flexDirection: "column",
          gap: 8,
        }}
      >
        {CONDITIONS.map((name, i) => (
          <div
            key={name}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 12px",
              background: "#f8fafc",
              borderRadius: 8,
              border: "1.5px solid var(--cc-border)",
            }}
          >
            <span
              style={{
                fontSize: 13,
                color: "var(--cc-text)",
              }}
            >
              {name}
            </span>

            <select
              value={conds[i]}
              onChange={(e) => {
                const next = [...conds];

                next[i] = e.target.value;

                setConds(next);
              }}
              style={{
                width: 80,
                margin: 0,
                padding: "5px 8px",
                fontSize: 13,
              }}
            >
              <option>No</option>
              <option>Yes</option>
            </select>
          </div>
        ))}
      </div>

      <div className="cc-divider" />

      <label className="cc-label-normal">
        Have any of your parents or siblings been diagnosed with cancer below age 60?
      </label>

      <select value={familyHist} onChange={(e) => setFamilyHist(e.target.value)}>
        <option>No</option>
        <option>Yes</option>
      </select>

      {result && (
        <div className={`cc-elig-result cc-show ${result.ok ? "cc-elig-ok" : "cc-elig-fail"}`}>
          {result.msg}
        </div>
      )}

      <button className="cc-btn cc-btn-purple" onClick={check} disabled={loading}>
        {loading ? "Checking..." : "Check Eligibility"}
      </button>
    </>
  );
}
